import { Component } from "react";
import { FormattedMessage } from "react-intl";
import new_survey_button from "../../Images/Healthform/New_survey.png";
import "../components-style.css";
import KidneyBloodForm from "./KidneyBloodForm.js";

class KidneyBloodDisplayNewForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  togglePopup = () => {
    this.setState({
      displayBreathingFormPopup: !this.state.displayBreathingFormPopup,
    });
  };

  render() {
    return (
      <div
        style={{
          flex: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "30%",
          height: "100%"
        }}
      >
        {this.props.accountInformation.readOnly === true ? null : (
          <button onClick={this.togglePopup} style={{ backgroundColor: "transparent", height: "100%" }}>
            <img
              src={new_survey_button}
              style={{
                height: "auto",
                maxHeight: "100%",
                width: "auto",
                maxWidth: "35px",
              }}
              alt="new_survey_logo"
            />
            <div style={{ fontSize: "0.875rem" }}>
              <FormattedMessage id="kidney.form.blood.title" />
            </div>
          </button>
        )}
        {this.state.displayBreathingFormPopup ? (
          <KidneyBloodForm
            cancelPopup={this.togglePopup}
            id_patient={this.props.id_patient}
            update={this.props.update}
            BannerDisplayedAlerts={this.state.BannerDisplayedAlerts}
            intl={this.props.intl}
            screenSize={this.props.screenSize}
          />
        ) : null}
      </div>
    );
  }
}
export default KidneyBloodDisplayNewForm;
